import client from "./client";

export async function getPreviousOrderSummary(publicOrderId: string) {
    const response = await client.get(
        `/user/orders/${publicOrderId}/previous-summary`,
    );

    return response.data;
}
